import { CustomerTab, OrderItem, Transaction } from "./schema";

export const getOrderItemTotals = (orderItems: OrderItem[]) =>
  orderItems
    .map((oi) => oi.totalSalesPriceTaxInclusive)
    .reduce((a, b) => a + b, 0);

export const sumTransactions = (transactions: Transaction[]) => {
  return transactions.map((t) => t.taxInclusive).reduce((a, b) => a + b, 0);
};

export const getOutstandingBalance = (customerTab: CustomerTab) => {
  const transactions = customerTab.transactions;
  return sumTransactions(transactions);
};
export const getMaxPaymentAmountFor =
  (customerTab: CustomerTab) => (toPay: number) => {
    const outstandingBalance = getOutstandingBalance(customerTab);
    return Math.min(outstandingBalance, toPay);
  };
